import React from "react";
import "../../../css/LandingPageHero.css";
import LandingPage1 from "../../../assets/images/LandingPage1.jpeg";
import LandingPage2 from "../../../assets/images/LandingPage2.jpeg";
import heroLogo from "../../../assets/images/HeroLogo.png";
import PrimaryButton from "../../designSystem/PrimaryButton";
import { useNavigate } from "react-router-dom";

const cards = [
  {
    id: 1,
    title: "Protecting your child’s education when life changes",
    buttonText: "FOR PARENTS",
    alt: "School children sitting together",
    image: LandingPage1,
    targetId: "services",
    type: "scroll",
  },
  {
    id: 2,
    title:
      "Fee protection advice for your families - at no cost to your school.",
    buttonText: "FOR SCHOOLS",
    alt: "Teacher with students in classroom",
    image: LandingPage2,
    path: "/for-schools",
    type: "route",
  },
];

const LandingPageHero = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleClick = (card) => {
    if (card.type === "scroll") {
      scrollToSection(card.targetId);
    } else if (card.type === "route") {
      navigate(card.path);
    }
  };
  return (
    <section className="home-hero">
      <div className="home-hero__wrapper">
        {/* CENTER LOGO */}
        <img src={heroLogo} alt="Logo" className="home-hero__logo" />
        <div className="home-hero__grid">
          {cards.map((card, index) => (
            <div className="home-hero__card" key={card.id}>
              <img
                src={card.image}
                alt={card.alt}
                className={`home-hero__image home-hero__image--${index + 1}`}
              />
              <div className="home-hero__overlay" />
              <div className="home-hero__content">
                <div className="content">{card.title}</div>
                <PrimaryButton
                  variant="outlined"
                  onClick={() => handleClick(card)}
                >
                  <div className="button-text">{card.buttonText}</div>
                </PrimaryButton>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingPageHero;